export const PERMISSION_AVAILABILITY_MAP = {
  'data-feeds-lake': 'awsLakeAvailable',
  'data-feeds-aws-arbitrated-pcaps': 'awsArbitratedPcapsAvailable',
  'data-feeds-aws-raw': 'awsRawFeedsAvailable',
} as const;

export const PERMISSION_TYPE_LABEL_MAP = {
  'data-feeds-lake': 'AWS Lake',
  'data-feeds-aws-arbitrated-pcaps': 'AWS Arbitrated PCAPs',
  'data-feeds-sftp05': 'SFTP05',
  'data-feeds-crushftp': 'CrushFTP',
  'data-feeds-aws-raw': 'AWS Raw Feeds',
  workbench: 'Workbench',
} as const;
